/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Conversion_TitleInputs */

const et_service_conversion_title = /** @type {(inputs: Service_Conversion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müügikonversiooni tõstmine kodulehel`)
};

const en_service_conversion_title = /** @type {(inputs: Service_Conversion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase Website Sales Conversion`)
};

/**
* | output |
* | --- |
* | "Increase Website Sales Conversion" |
*
* @param {Service_Conversion_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_conversion_title = /** @type {((inputs?: Service_Conversion_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Conversion_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_conversion_title(inputs)
	return en_service_conversion_title(inputs)
});